(() => {
  // évite double init
  if (window.__ysWishlistInit) return;
  window.__ysWishlistInit = true;

  const KEY = 'ys_wishlist_handles_v1';

  const safeRead = () => {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  };

  const safeWrite = (arr) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {
      // localStorage peut être bloqué dans certains contextes
    }
  };

  const norm = (h) => String(h || '').trim();

  const has = (handle) => {
    handle = norm(handle);
    if (!handle) return false;
    return safeRead().includes(handle);
  };

  const toggle = (handle) => {
    handle = norm(handle);
    if (!handle) return;

    const list = safeRead();
    const idx = list.indexOf(handle);
    if (idx >= 0) list.splice(idx, 1);
    else list.push(handle);

    safeWrite(list);
  };

  const paintBtn = (btn) => {
    if (!btn) return;

    const handle = norm(btn.dataset.handle || btn.getAttribute('data-handle'));
    if (!handle) return;

    const heart = btn.querySelector('.ys-wishlist-heart');
    const active = has(handle);

    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');

    if (heart) heart.textContent = active ? '♥' : '♡';
  };

  const paintAll = (root = document) => {
    root.querySelectorAll('[data-ys-wishlist]').forEach(paintBtn);
  };

  // --- clic robuste (délégation) : marche même si Shopify re-render ---
  let lastPointerTs = 0;

  const handleToggleEvent = (e) => {
    const btn = e.target?.closest?.('[data-ys-wishlist]');
    if (!btn) return;

    // évite que d'autres scripts "parasites" capturent le clic
    e.preventDefault?.();
    e.stopPropagation?.();
    e.stopImmediatePropagation?.();

    toggle(btn.dataset.handle || btn.getAttribute('data-handle'));
    paintAll(document);
  };
try {
  document.dispatchEvent(new CustomEvent('ys:wishlist:change', { detail: { handles: safeRead() } }));
} catch (e) {}

  // Mobile/iOS : pointerup fiable, puis fallback click
  document.addEventListener('pointerup', (e) => {
    lastPointerTs = Date.now();
    handleToggleEvent(e);
  }, true);

  document.addEventListener('click', (e) => {
    // évite double toggle si pointerup a déjà déclenché
    if (Date.now() - lastPointerTs < 400) return;
    handleToggleEvent(e);
  }, true);

  // init même si le script est chargé APRÈS DOMContentLoaded
  const boot = () => paintAll(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify editor / sections
  document.addEventListener('shopify:section:load', (e) => paintAll(e.target || document));
  document.addEventListener('shopify:section:reorder', boot);

  // sync entre onglets
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) paintAll(document);
  });
})();
